import { FC, ReactElement } from "react";
import styles from "./StickyBottom.module.css";
import classNames from "classnames";
import { Container } from "ui-kit/Layout";
import Gutter from "ui-kit/Gutter";
import { Typography } from "ui-kit/Typography";

type StickyBottomProps = {
  button: ReactElement;
  highlights?: Record<string, string>;
  transparent?: boolean;
};

const StickyBottom: FC<StickyBottomProps> = ({
  button,
  highlights,
  transparent,
}) => (
  <div className={classNames(styles.sticky, transparent && styles.transparent)}>
    <Container style={{ textAlign: "center" }}>
      {button}
      {highlights && (
        <>
          <Gutter size={1} />
          <Typography variant="body4" color="grey400">
            {Object.entries(highlights)
              .map(([key, value]) => `${key} ${value}`)
              .join(" - ")}
          </Typography>
        </>
      )}
    </Container>
  </div>
);

export default StickyBottom;
